export const isValidTimezoneFormat = (timezone: string): boolean =>
  /^[a-zA-Z]+(?:\/[a-zA-Z_-]+)+$/.test(timezone);

export const isValidTzOffsetFormat = (tzOffset: string): boolean =>
  /^(?:Z|([+-])(0[0-9]|1[0-2]):([0-5][0-9]))$/.test(tzOffset);
